import React from 'react';

export default function TelegramBtnIcon() {
	return (
		<svg
			width='18'
			height='18'
			viewBox='0 0 18 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M15.5 1.15625C16.2188 0.71875 17.0938 1.34375 16.9688 2.15625L14.9688 15.1875C14.875 15.8438 14.1875 16.2188 13.5938 15.9688L9.65625 14.3438L7.75 16.6562C7.15625 17.375 6 16.9688 6 16V12.8125L1.59375 11C0.84375 10.6875 0.78125 9.625 1.5 9.21875L15.5 1.15625ZM7 16L8.6875 13.9375L7 13.25V16ZM14 15.0625L16 2L2 10.0938L5.53125 11.5625L13.5 4.75C13.6875 4.59375 13.9375 4.84375 13.7812 5.03125L7.53125 12.375L14 15.0625Z'
				fill='white'
			/>
		</svg>
	);
}
